/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Home_Comment_AuthorInputs */

const en_wc_home_comment_author = /** @type {(inputs: Wc_Home_Comment_AuthorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getting started`)
};

/**
* | output |
* | --- |
* | "Getting started" |
*
* @param {Wc_Home_Comment_AuthorInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_home_comment_author = /** @type {((inputs?: Wc_Home_Comment_AuthorInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Home_Comment_AuthorInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_home_comment_author(inputs)
});
export { wc_home_comment_author as "wc.home.comment_author" }